import * as S from './styles'

import { ModalProps } from '@mui/material'

interface IModalProps extends ModalProps {
  width?: string
  className?: string
}

const Modal = ({ children, className, ...rest }: IModalProps) => {
  return (
    <S.Wrapper {...rest} className={className}>
      <S.Container width={rest.width}>{children}</S.Container>
    </S.Wrapper>
  )
}

export { Modal }
export type { IModalProps }
